<template>
  <div>
    <div class="index-container transitionBody">
      <div class="activity">
        <div class="hall-head_box">
          <div class="hall-head">
            优惠活动
            <div class="xzimg"></div>
            <div class="xxbox" @click="$parent.openKefu()"><!----></div>
          </div>

          <div data-v-730dfc06="" class="navcontent">
            <div data-v-730dfc06="" class="navbars">
                <div data-v-730dfc06="" @click="type=0" :class="{active:type==0}" class="navbar"> 全部优惠 </div>
                <div data-v-730dfc06="" @click="type=1" :class="{active:type==1}" class="navbar"> 限时活动 </div>
                <div data-v-730dfc06="" @click="type=2" :class="{active:type==2}" class="navbar"> 新人首存 </div>
                <div data-v-730dfc06="" @click="type=3" :class="{active:type==3}" class="navbar"> 日常活动 </div>
            </div>
        </div>

        </div>

        <!----><!---->
        <div class="activecont">
          <div class="activeinner">
            <div class="PulldownRefresh">
              <div class="van-pull-refresh">
                <div class="van-pull-refresh__track" style="transition-duration: 0ms">
                  <div class="van-pull-refresh__head" style="height: 80px"></div>
                  <div class="main_content" v-if="type==0">
                    <div class="activebox" v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activityInfo?id=${item.id}`)">
                      <img :src="item.banner" />
                    </div>
                  </div>
                  <div v-else data-v-9349a398="" class="main_content">
                    <div data-v-730dfc06="" class="expectation"><img data-v-730dfc06="" src="/static/img/expectation.ccc42cce.png"
                            alt=""></div>
                </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
      type:0
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.activity {
  width: 100%;
  background-color: #fff;
  height: 100%;
  overflow: hidden;
}
.activity div::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
.activity .colosline {
  width: 100%;
  height: 0.08rem;
  background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
  background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.activity .backhead {
  width: 100%;
  height: 1.17333rem;
  border-bottom: 0.02667rem solid #f6f6f6;
  font-size: 0.45333rem;
  color: #424653;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  background: #fff;
}
.activity .backhead img {
  width: 0.64rem;
  height: 0.64rem;
  position: absolute;
  left: 0.26667rem;
  top: 0.26667rem;
}
.activity .hall-head {
  
  box-sizing: border-box;
  height: 1.17333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  font-size: 0.50667rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #424653;
}
.hall-head_box{
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
}
.activity .hall-head .xzimg {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAZlBMVEUAAABeYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm2tmYJeYm2tmYKtmYJeYm1eYm2tmYKtmYKtmYKtmYKtmYKtmYJeYm2tmYKpvTjFAAAAIHRSTlMACfTaWBzKw66eknRNRzg0LHxbH86EjQrc3t2taUcrGOUgPYIAAAE/SURBVDjLpZXrkoIwDIXTAIKCeAEB7/D+L7mkrJs2kaKz5wcztN805CQN4MuUedYhdlleGpjXdtU7Wm1nsBh7IYxBK4n6N4oqddy0kRaJsd+aFOm0Ig492MX1Hhzt13bxoLkdCO0keaT3jQEls6Gd4+u1orcTvNWJ9l4ZRXQezIjO7JyEZ+tgODjKPHRGaOtGvgCrGUgNL5BLVE2qr+vfMMnxk+o+fUMKIRBSm0M5PoswWIxICfn4TMJgMiI5ZOyNBtmhzLoNYRCo3wAdsB581QyiBz4F+HRAP/TD4x5uaJHM3eHuXjLSntsfdxP2SMObX64RhusSXi13lSXUTQE1G8NNwW3Gai/DpQXdZrpx27qVjfvpVYg/vFzRl9d1eQB8M1I4wvKQ4uh67HFcVhUapMuj+T/Dnn8fZ8Sz/n38ADWZQnzOMijZAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  right: 1.61333rem;
}
.activity .hall-head .kefuicon,
.activity .hall-head .xzimg {
  width: 0.53333rem;
  height: 0.53333rem;
  margin-top: 0.08rem;
  position: absolute;
  top: 0.29333rem;
}
.activity .hall-head .kefuicon {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAilBMVEUAAABdYm1eYm1eYm1eYm1paXBeYm1bZm5eYm1dYW1dYm5dYm5dY3BeYm1dYm1eYm1eYm3xjlZeYm3xjlbxj1byjlZeYmxeYW1dY21eYmxeYm3rj1FeYm1eYm1eYm1eYm5gYG9eYW5hYWnxjlZeYm3xjlXwjlZfYm3yjlfyjFXxjlVdYm5eYm3xjlZfMdjrAAAALHRSTlMA8Pv1ygbqEp14HxsNxaukXNvTz6yXb2NRTEYM5JOAODMlCfezs56MTzwSawcR0WQAAAFYSURBVDjLxZNZtoMgEEQRRY1TYtQ4a+bp4f639+g4HUSif6mPHC1ubLqgES+Slq6Ose6WKUFyOZVOB+mVI+OygnIqsnluQwVt5JxqJhYhVrJVZWRCQVu7f7e9j5FMOQPawH9CCd2YgA9w45nNPCbBqFAXTXSFTfMh7aCwPQVPmNk7ztoyx0OCPKHOfvirUGjPOQpzLBG0YJNDMCajQEQESbuimAZ71mgnNKN+TSPoQBdB0AFp60ANqZ82voHIhpY65BvYZvJDcHUzfDz+7Zm3RP68+Vw8Y+AF86OmaYIwisKAPURc4MMR4hS+A0CnIOeOsLsUundEoHfYc+GbvZ7HSyHodfcvF//+aq84jJfIzF9cdw0Io1Cu4GwYrmwFaHIjI1cGHafLXA1HbEqXjxpm6Wu1U2Fo+SzjjG4kVRV+r1IOxXSUEoOzCO43DhhLpZUTZ0ubceup/w/07lIHQOGMRwAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
  right: 1.34667rem;
}
.activity .hall-head .xxbox {
  width: 0.53333rem;
  height: 0.53333rem;
  margin-top: 0.08rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAkFBMVEUAAADyjlVeYm1cX2rxjVX1hE5fYm5eYW1eYm1dYWxcXmlRVWReYW1eYmxdYm3xjlZdYm1eYm1cYWxeYm3yjlVdYWxdYm1dYW1dYm1dYW1dYm1eYmxdYmxdYW1dYWxdYWxbYGpeZG9aYGteYWxdYm1eYWzxjlVeYm3xjlVeYW3xjVVcYWtbYW1bYGxeYm3xjlbDgLzLAAAALnRSTlMA6/cRjAaqj4I8Fwiwevvv6N1Q7o+L6+LSrKB01tVeVjMuH6aSaZNB8suSSiotIcUsigAAAbJJREFUOMuFVWljgjAMDeC470u5D3XOY93//3drSh0WpHsfIE2ebV8SIoiwvKJJfD9pCs+CTdjmnrxgb9pvadpJJQuoJ23Ni3PyBnm85BlTIDK6h+aA9uiMaPIYAs0pmLOwBGHu5HRgho6eeqXTqtGvL87VHVjBKYXTY1yV8BYZxrgiLaS2CxvAPUNt+tFkbsBpaDhj9cA8t7AJCzOPNTKpcQAJMEsmfWNizwDyLSOAgb58DWTArQao6PMKUmCaK1YUQ07sWHkO/IofO0VJP7ixE4yByU145nc/FJ9PY0eNFI0bVoRSEvDp80JXAbq/qKGgoTw9AVCgXka8Y1xOVAEbu3s9OhWORo+Drc7EeHj1VAluopg0CJi8kYnRmXYpLKSwhIdy4pklfCBctrwrhqmSRxlPU1lTgIdZGiXEisu1VfmWds4bF46U2MhvmDGr5h28hvhFjSj7W8Yj8V+W6i3BLvIM4dvps/1xod1pQ+S5fJVgV5gRutTSmmmjN41Vl4+aCxEQ6l57j1uvrMli7JlEhnAepKen71rKR3OP4URv7X+HfW+Y1ryo8O9DzQ+614OAX3aDW0yTQtmhAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0.53333rem;
  top: 0.29333rem;
}
.activity .hall-head .xxbox font {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 50%;
  background: #f18e56;
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
}
.activity .navcontent {
  float: left;
  width: 100%;
  height: 1.06667rem;
  background: #fff;
  overflow-y: hidden;
  overflow-x: scroll;
  margin-bottom: 0.26667rem;
}
.activity .navcontent .navbars {
  width: auto;
  height: 0.81333rem;
  margin-top: 0.18667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  white-space: nowrap;
}
.activity .navcontent .navbars .navbar {
  padding: 0.13333rem 0.26667rem;
  // height: 0.81333rem;
  margin-left: 0.46667rem;
  color: #9ca3bf;
  font-size: 0.34667rem;
  font-weight: 500;
  text-align: center;
}
.activity .navcontent .navbars .active {
  color: #4f8dfe;
}
.activity .activecont {
  width: 100%;
  padding-top: 2.4rem;
  height: calc(100% - 3.65333rem);
  padding-bottom: 1rem;
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .activecont .activeinner {
  width: 100%;
  padding: 0.4rem 0.4rem 0.26667rem 0.4rem;
  padding-top: 0 !important;
}
.activity .activecont .activeinner .activebox {
  overflow: hidden;
  width: 9.2rem;
  height: 3.86667rem;
  margin-top: 0.26667rem;
  position: relative;
  border-radius: 0.26667rem;
}
.activity .activecont .activeinner .activebox img {
  width: 9.2rem;
  height: 3.86667rem;
}
.activity .activecont .activeinner .activebox:first-child {
  margin-top: -0.13333rem;
}
.activity .activecont .activeinner .expectation {
  padding-top: 0.4rem;
}
.activity .activecont .activeinner .expectation img {
  width: 92%;
}
.activity .contentsds {
  width: 100%;
  height: calc(100% - 1.17333rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .contentsds .contentsdsinner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue